import { render, staticRenderFns } from "./DispatchImporter.vue?vue&type=template&id=70ec2b02"
import script from "./DispatchImporter.vue?vue&type=script&lang=js"
export * from "./DispatchImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports